
import * as Yup from 'yup';

export const getCreateEstablishmentSchema = () => {
  return Yup.object().shape({
    establishmentName: Yup.string().required('Establishment Name is required'),
    street: Yup.string().required('Street is required'),
    state: Yup.string().required('State is required'),
    city: Yup.string().required('City is required'),
    establishment_type: Yup.string().required('Establishment Type is required'),
    size: Yup.string().required('Size is required'),

    zip: Yup.string()
    .required('Zip is required')
    .matches(/^\d{5}(\d{4})?$/, 'Zip must be 5 or 9 digits'),  
    industryDescription: Yup.string().required(
      'Industry Description is required',
    ),
    classification: Yup.string()
      .required('Classification is required')
      .matches(/^\d{6}$/, 'Classification must be exactly 6 digits'),
  });
};
